(function () {
  function initSlider(root) {
    const inner = root.querySelector('.cs-inner');
    const range = root.querySelector('.cs-range');

    if (!inner || !range) return;

    function setPos(value) {
      const percent = Math.min(100, Math.max(0, Number(value)));
      inner.style.setProperty('--pos', percent + '%');
    }

    setPos(range.value);

    range.addEventListener('input', function () {
      setPos(this.value);
    });
  }

  function init() {
    document.querySelectorAll('.cs-root').forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:block:select', init);
})();

document.querySelectorAll('.cs-inner').forEach((slider) => {

  const range = slider.querySelector('.cs-range');
  const beforeLabel = slider.querySelector('.cs-label--before');
  const afterLabel = slider.querySelector('.cs-label--after');

  function updateSlider() {
    const value = parseInt(range.value);

    slider.style.setProperty('--pos', value + '%');

    /* FIRST IMAGE = BEFORE */
    beforeLabel.style.opacity = value < 35 ? '0' : '1';

    /* SECOND IMAGE = AFTER */
    afterLabel.style.opacity = value > 65 ? '0' : '1';
  }

  range.addEventListener('input', updateSlider);

  updateSlider();
});